__turbopack_context__.v({
  "backdrop": "UTfL3q_backdrop",
  "chevron": "UTfL3q_chevron",
  "endAdornment": "UTfL3q_endAdornment",
  "item": "UTfL3q_item",
  "itemContent": "UTfL3q_itemContent",
  "placeholder": "UTfL3q_placeholder",
  "popup": "UTfL3q_popup",
  "positioner": "UTfL3q_positioner",
  "selectControl": "UTfL3q_selectControl",
  "selectTrigger": "UTfL3q_selectTrigger",
  "value": "UTfL3q_value",
});
